<template>
    <BaseButton
        tag="button"
        modifier="medium"
        @click="refineAndScroll"
    >
        View more
    </BaseButton>
</template>
<script>
export default {
    name: 'AlgoliaSearchLoadMore',
    methods: {
        refineAndScroll() {
            const position = document.querySelector('.AlgoliaHits').lastChild.offsetTop;
            this.$emit('refine');
            console.log(position);
            setTimeout(() => {
                window.scrollTo(0, position);
            }, 650);
        },
    }
}
</script>
